var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.716 8.675a1.014 1.014 0 0 1 1.531 0l3.796 4.661c.267.4.267.933 0 1.266l-3.795 4.66c-.4.467-1.133.467-1.532 0l-3.796-4.66c-.266-.4-.266-.933 0-1.266l3.796-4.661zm-11.72 0a1.014 1.014 0 0 1 1.531 0l3.796 4.661c.266.4.266.933 0 1.266l-3.796 4.66c-.4.467-1.132.467-1.531 0L5.2 14.603c-.267-.4-.267-.933 0-1.266l3.796-4.661zm7.391-7.325 3.796 4.661c.266.4.266.933 0 1.266l-3.796 4.662c-.4.466-1.132.466-1.531 0L11.06 7.276c-.266-.4-.266-.932 0-1.265l3.796-4.66a1.014 1.014 0 0 1 1.531 0zm-1.531 18.712-3.796 4.662c-.266.333-.266.865 0 1.265l3.796 4.66c.4.467 1.132.467 1.531 0l3.796-4.661c.266-.4.266-.933 0-1.266l-3.796-4.662a1.013 1.013 0 0 0-1.531 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsv);
export default __webpack_public_path__ + "static/media/SSV.1d9ae3c87bb8188d63b535d263593158.svg";
export { ForwardRef as ReactComponent };